export default "__VITE_ASSET__CSu7fGSo__"